import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

const useModal = createWithEqualityFn(
  (set) => ({
    isModalActive: false,
    setIsModalActive: (value) => set({ isModalActive: value }),

    isServiceSelected: false,
    setIsServiceSelected: (value) => set({ isServiceSelected: value }),

    isServiceConnected: false,
    setIsServiceConnected: (value) => set({ isServiceConnected: value }),

    isModalAddEmployee: false,
    setIsModalAddEmployee: (value) => set({ isModalAddEmployee: value }),

    fetchedServiceData: null,
    setFetchedServiceData: (value) => set({ fetchedServiceData: value }),

    isCurrentArticle: '',
    setIsCurrentArticle: (value) => set({ isCurrentArticle: value }),

    selectedServiceItemId: null,
    setSelectedServiceItemId: (value) => set({ selectedServiceItemId: value }),

    selectedRole: null,
    setSelectedRole: (value) => set({ selectedRole: value }),
  }),
  shallow
);

export default useModal;